import { ResetPageReason, AddPaymentMethodResultCode } from '../../payer-onboarding-generated';

export enum PayerOnboardingErrorType {
	Generic,
	ShouldReloadPage,
	AddPaymentMethodError,
	MobileNumberInUseError,
	AccountAlreadyActiveError,
}

export interface IGenericError {
	errorType: PayerOnboardingErrorType.Generic;
	message: string;
}

export interface IShouldReloadPageError {
	errorType: PayerOnboardingErrorType.ShouldReloadPage;
	reason: ResetPageReason;
}

export interface IAddPaymentMethodError {
	errorType: PayerOnboardingErrorType.AddPaymentMethodError;
	errorResultCode: AddPaymentMethodResultCode;
	errorMessageLines: string[];
}

export interface IMobileNumberInUseError {
	errorType: PayerOnboardingErrorType.MobileNumberInUseError;
	message: string;
	loginUrl: string;
}

export interface IAccountAlreadyActiveError {
	errorType: PayerOnboardingErrorType.AccountAlreadyActiveError;
	message: string;
	loginUrl: string;
}

export type PayerOnboardingError = IGenericError | IShouldReloadPageError | IAddPaymentMethodError | IMobileNumberInUseError | IAccountAlreadyActiveError;
